<template>
  <q-page padding>
    <base-list :readonly="readonly"></base-list>
  </q-page>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'List',
  computed: {
    ...mapGetters('auth', ['user', 'roles', 'hasRole']),
    readonly () {
      if (this.hasRole('Super Admin') || this.hasRole('Super Admin') || this.hasRole('Super Admin')) {
        return false
      }
      return true
    }
  }
}
</script>
